import { useContext } from 'react';
import { KoalyThemeSettingsProvider } from '../ThemeProvider.js';

const useLinkWrapper = () => {
    const { linkWrap } = useContext(KoalyThemeSettingsProvider);
    return (link) => {
        return linkWrap ? linkWrap(link) : link;
    };
};

export { useLinkWrapper };
//# sourceMappingURL=useLinkWrapper.js.map
